import { GridContainer } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'
import { CookieSettings } from '@websrc/App/Components/CookieConsent/CookieConsent'
import { Markdown } from '@websrc/App/Components/Markdown/Markdown'
import { getCookieConsent } from '@websrc/App/Helpers/cookieUtil'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { mapCookiePolicy } from '@websrc/DataMappers/mapCookiePolicy'
import { mapFooter } from '@websrc/DataMappers/mapFooter'
import { button, styles } from 'leds'
import React, { ComponentPropsWithoutRef, useState } from 'react'

export type FooterPrivacyProps = ComponentPropsWithoutRef<'div'> & {
  cookiePolicy: ReturnType<typeof mapCookiePolicy>
  copyright: ReturnType<typeof mapFooter>['copyright']
  policy: ReturnType<typeof mapFooter>['policy']
}

export const FooterPrivacy = ({
  copyright,
  policy,
  cookiePolicy,
  ...divProps
}: FooterPrivacyProps) => {
  const [showCookieSettings, setShowCookieSettings] = useState(false)
  const t = useStaticText()

  const currentConsent = getCookieConsent()

  const cookies = cookiePolicy.preferences.map((pref) => ({
    ...pref,
    selected:
      pref.category === 'necessary' ||
      Boolean(currentConsent?.preferences?.find((cat) => cat.key === pref.category && cat.value)),
  }))

  return (
    <>
      <div className={'container-coral-spot'}>
        <GridContainer
          className={styles({
            marginY: 42,
            padding: 0,
          })}
          style={{ paddingLeft: 0, paddingRight: 0 }}
        >
          <div role={'contentinfo'} {...divProps}>
            <div
              className={styles({
                display: { print: 'none', screenXS: 'flex' },
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                marginBottom: 16,
              })}
            >
              {policy.map((link, key) => (
                <a className={button({ type: 'link', fontSize: 'md' })} href={link.url} key={key}>
                  {link.image && (
                    <Asset
                      className={styles({ marginRight: 5 })}
                      height={20}
                      lazyLoading={false}
                      thumbnail={link.image}
                      width={20}
                    />
                  )}
                  <span>{link.title}</span>
                </a>
              ))}
              <button
                className={button({ type: 'link', fontSize: 'md' })}
                onClick={() => setShowCookieSettings(true)}
              >
                {t.cookies.cookie_settings}
              </button>
            </div>
            <Markdown
              className={styles({
                maxWidth: 'full',
                textAlign: 'left',
                display: { print: 'none' },
              })}
              markdown={copyright}
              skipWidth={true}
              style={{
                fontSize: '14px',
              }}
            />
            {showCookieSettings && (
              <CookieSettings
                acceptSettingsCallback={() => setShowCookieSettings(false)}
                cancelSettingsCallback={() => setShowCookieSettings(false)}
                current={cookies}
              />
            )}
          </div>
        </GridContainer>
      </div>
    </>
  )
}
